export default {
    SELECT_ELEMENT: "Выберите элемент",
    ALL: "Все"
};
